import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import BotPage from "./pages/BotPage";
// import Login from "./pages/Login"; // disabled: auth is handled by stg2.xenorize.com
import ForwardTesting from "./pages/ForwardTesting";
import ConnectExchange from "./pages/ConnectExchange";

const SPOT_ROOT = (process.env.REACT_APP_SPOT_URL || "https://stg2.xenorize.com/dashboard")
  .replace(/\/dashboard$/, "");

function LoginRedirect() {
  window.location.replace(SPOT_ROOT);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginRedirect />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/bot" element={<BotPage />} />
        <Route path="/forward-testing" element={<ForwardTesting />} />
        <Route path="/connect-exchange" element={<ConnectExchange />} />
        <Route path="/" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
